exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-profile-___profile__container___2XnLq {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n#profile-body-placeholder {\n  flex: 1;\n  display: flex;\n  width: 80%;\n  max-width: 1300px;\n  margin: 0 auto;\n  padding: 100px 30px 30px 30px;\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-profile-___profile__container___2XnLq"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/profile/profile.scss
// module id = 2467
// module chunks = 0